(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
(function() {
  // Only run on desktop
  if (window.innerWidth <= 749) return;
  
  function initEnhancedSticky() {
    // Find the gallery - try multiple selectors based on your theme
    const gallery = document.querySelector('.product-information__media') ||
                   document.querySelector('.premium-product-gallery') ||
                   document.querySelector('.product-media-gallery--sticky');
    
    // Find the product details container
    const details = document.querySelector('.product-details') ||
                   document.querySelector('.sticky-content--desktop');
    
    if (!gallery || !details) {
      console.log('Enhanced sticky: Gallery or details not found');
      return;
    }
    
    console.log('Enhanced sticky gallery initialized');
    
    let ticking = false;
    
    function updateGalleryPosition() {
      // Get the parent container (should be the grid)
      const gridContainer = gallery.parentElement;
      if (!gridContainer) return;
      
      const gridRect = gridContainer.getBoundingClientRect();
      const galleryRect = gallery.getBoundingClientRect();
      const detailsRect = details.getBoundingClientRect();
      
      // Get header height
      const header = document.querySelector('sticky-header') || 
                    document.querySelector('header') || 
                    document.querySelector('[class*="header"]');
      const headerHeight = 0;
      
      const stickyTopBase = 20; // 20px spacing from top
      const galleryHeight = gallery.offsetHeight;
      const detailsHeight = details.offsetHeight;
      const viewportHeight = window.innerHeight;
      
      // If gallery is taller than viewport, let it scroll normally
      if (galleryHeight > viewportHeight - stickyTopBase) {
        gallery.style.top = `${stickyTopBase}px`;
        return;
      }
      
      // Calculate the bottom position of details relative to viewport
      const detailsBottom = detailsRect.bottom;
      const galleryBottom = galleryRect.top + galleryHeight;
      
      // If details are scrolled up and their bottom is above where gallery bottom would be
      if (detailsBottom <= viewportHeight && detailsBottom < galleryBottom) {
        // Calculate how much to adjust the gallery position
        const adjustment = galleryBottom - detailsBottom;
        const newTop = Math.max(stickyTopBase - adjustment, headerHeight - galleryHeight + viewportHeight);
        gallery.style.top = `${newTop}px`;
      } else {
        // Keep gallery at normal sticky position
        gallery.style.top = `${stickyTopBase}px`;
      }
      
      ticking = false;
    }
    
    function requestTick() {
      if (!ticking) {
        window.requestAnimationFrame(updateGalleryPosition);
        ticking = true;
      }
    }
    
    // Listen to scroll events
    window.addEventListener('scroll', requestTick, { passive: true });
    window.addEventListener('resize', requestTick);
    
    // Initial positioning
    requestTick();
    
    // Update after images might load
    setTimeout(requestTick, 100);
    setTimeout(requestTick, 500);
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initEnhancedSticky);
  } else {
    initEnhancedSticky();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
